export default __webpack_public_path__ + "b1cdcb57c87a7a65345778cc7ee96c6d.png";